<template>
  <el-main class="iDalgo-User-Edit">
    <!-- Breadcrumb __ First row -->
    <el-row type="flex" class="card align-center">
      <el-col :span="18">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'users' }">{{ $t('iDalgoCRMEdit.users') | capitalize }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ breadcrumbTitle }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="6" class="flex-end">
        <button @click="handleSave" class="button-icon">
          <svgicon name="save"></svgicon>
          <span>{{ $t('actions.save') }}</span>
        </button>
        <button @click="handleDelete" class="button-icon">
          <svgicon name="bin"></svgicon>
          <span>{{ $t('actions.delete') }}</span>
        </button>
      </el-col>
    </el-row>

    <!-- Save status __ Second row -->
    <el-row>
      <span class="user-created-at">{{ $t('iDalgoCRMEdit.saveStatus.createdAt') }} :<b>{{ createdAt | moment('DD/MM/Y à HH:mm') }}</b></span>
    </el-row>

    <!-- User edit form container ___ Third row -->
    <el-row class="flex-start" :gutter="20" type="flex">
      <!-- User edit form ___ Third row -->
      <el-col :span="24">
        <el-form :model="user" :rules="rules" ref="form">
          <el-form-item prop="customer">
            <el-select
              v-model="user.customer"
              :loading="customersLoader"
              filterable
              :placeholder="$t('iDalgoCRMNew.form.customerField')">
              <el-option
                v-for="item in customers"
                :key="item.id"
                :label="item.txt_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="firstName">
            <el-input v-model="user.firstName" :placeholder="$t('iDalgoCRMNew.form.firstNameField')"></el-input>
          </el-form-item>
          <el-form-item prop="lastName">
            <el-input v-model="user.lastName" :placeholder="$t('iDalgoCRMNew.form.lastNameField')"></el-input>
          </el-form-item>
          <!-- user.username corresponds to an email adress -->
          <el-form-item prop="username">
            <el-input v-model="user.username" :placeholder="$t('iDalgoCRMNew.form.emailField')"></el-input>
          </el-form-item>
          <el-form-item prop="plainPassword">
            <el-input type="password" v-model="user.plainPassword" :placeholder="$t('iDalgoCRMNew.form.passwordField')"></el-input>
          </el-form-item>
          <el-form-item prop="role">
            <el-select v-model="user.role" :placeholder="$t('iDalgoCRMNew.form.roleField')" style="width: 100%;">
              <el-option :label="$t('iDalgoCRMNew.form.roleUser')" value="ROLE_USER"></el-option>
              <el-option :label="$t('iDalgoCRMNew.form.roleAdmin')" value="ROLE_ADMIN"></el-option>
              <el-option :label="$t('iDalgoCRMNew.form.roleSuperUser')" value="ROLE_SUPERUSER"></el-option>
            </el-select>
          </el-form-item>
          <!-- products -->
          <el-form-item :label="$t('iDalgoCRMNew.form.productField')">
            <el-checkbox-group v-model="user.products">
              <el-checkbox label="PRODUCT_SURVEY">{{ $t('iDalgoCRMNew.form.productSurvey') }}</el-checkbox>
              <el-checkbox label="PRODUCT_BAROMETER">{{ $t('iDalgoCRMNew.form.productBarometer') }}</el-checkbox>
              <el-checkbox label="PRODUCT_PLAYERLIST">{{ $t('iDalgoCRMNew.form.productPlayerList') }}</el-checkbox>
              <el-checkbox label="PRODUCT_LIVEBLOG">{{ $t('iDalgoCRMNew.form.productLiveblog') }}</el-checkbox>
              <el-checkbox label="PRODUCT_PREDICTOR">{{ $t('iDalgoCRMNew.form.productPredictor') }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <i-dalgo-button @click="handleSave" :loading="isLoading" style="width: 100%">{{ $t('actions.save') }}</i-dalgo-button>
        </el-form>
      </el-col>
    </el-row>

  </el-main>
</template>

<script>
import iDalgoButton from '@/components/iDalgo-Button'
import { mapGetters } from 'vuex'
import { getCopy } from '@/services/tools'

export default {
  name: 'iDalgo-User-Edit',
  components: {
    iDalgoButton
  },
  computed: {
    ...mapGetters({
      models: 'users/models',
      user: 'users/user',
      isLoading: 'users/isLoading',
      customers: 'customers/customers',
      customersLoader: 'customers/isLoading'
    }),
    createdAt () {
      return this.user.createdAt ? this.user.createdAt : new Date()
    },
    breadcrumbTitle () {
      // Both firstName and lastName to prevent Null display
      return (this.user.firstName && this.user.lastName) ? this.user.firstName + ' ' + this.user.lastName : this.user.username
    }
  },
  data () {
    return {
      rules: {
        customer: [
          { required: true, message: this.$t('iDalgoCRMNew.formRules.customer.requiredMessage'), trigger: 'blur' }
        ],
        username: [
          { required: true, message: this.$t('iDalgoCRMNew.formRules.email.requiredMessage'), trigger: 'blur' },
          { min: 3, max: 255, message: this.$t('iDalgoCRMNew.formRules.email.sizeMessage'), trigger: 'blur' },
          { type: 'email', message: this.$t('iDalgoCRMNew.formRules.email.invalidEmail'), trigger: 'blur' }
        ],
        plainPassword: [
          { min: 3, max: 255, message: this.$t('iDalgoCRMNew.formRules.plainPassword.sizeMessage'), trigger: 'blur' }
        ],
        role: [
          { required: true, message: this.$t('iDalgoCRMNew.formRules.role.requiredMessage'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleSave () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            // Save user
            let filteredUser = JSON.parse(JSON.stringify(this.user))
            // Remove null values
            Object.entries(filteredUser).forEach(o => (o[1] === null ? delete filteredUser[o[0]] : 0))
            await this.$store.dispatch('users/updateUser', filteredUser)
            // user update succeeded
            this.$notify({
              title: this.$t('iDalgoCRMUpdateNotification.successTitle'),
              message: this.$t('iDalgoCRMUpdateNotification.successMessage'),
              type: 'success'
            })
            this.$router.push({ name: 'users' })
          } catch (e) {
            this.$notify.error({
              title: this.$t('iDalgoCRMUpdateNotification.errorTitle'),
              message: this.$t('iDalgoCRMUpdateNotification.errorMessage')
            })
            this.$store.dispatch('auth/checkStatus', e.response.status)
            throw e
          }
        } else {
          return false
        }
      })
    },
    handleDelete () {
      let message = this.$t('iDalgoDialogs.deleteUser.notification')
      this.$confirm(this.$t('iDalgoDialogs.deleteUser.message'), this.$t('iDalgoDialogs.deleteUser.title'), {
        confirmButtonText: this.$t('actions.delete'),
        cancelButtonText: this.$t('actions.cancelButton'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('users/deleteUser', this.user.id).then(() => {
          this.$notify({
            message
          })
          this.$router.push({ name: 'users' })
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.$store.dispatch('users/getUser', this.$route.params.id)
  },
  beforeDestroy () {
    // when changing page / refreshing, reset user so the next form won't have any residue
    this.$store.commit('users/USER_UPDATED', getCopy(this.models.user))
  }
}
</script>

<style lang="scss">
.iDalgo-User-Edit {
  .el-breadcrumb__item {
    .el-breadcrumb__inner {
      font-family: 'robotoregular' !important;
      font-weight: normal;
    }

    &:last-child .el-breadcrumb__inner {
      color: $color2 !important;
      font-family: 'robotoregular' !important;
    }
  }

  .user-created-at {
    color: lighten($text-gray, 10%);
    font-size: 11px;
    margin-right: $default_padding;
    padding: 0;
    display: inline-flex;
    margin: 20px $default_padding 4px $default_padding;

    b {
      margin-left: $default_padding / 2;
    }
  }

  .el-form {
    margin: auto;

    .el-form-item {
      display: flex;
      flex-direction: column;

      .el-checkbox {
        margin: 0;

        &__label {
          font-size: 16px;
          color: $color1;
          font-family: 'robotoregular';
        }

        &-group {
          display: flex;
          flex-direction: column;
        }
      }

      .el-form-item__label {
        color: $color1;
        font-size: 32px;
        text-align: left;
      }
    }
  }

  .button-icon {
    border: none;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s;

    span {
      transition: all 0.2s;
    }

    .svg-icon {
      transition: all 0.2s;
    }

    &:hover {
      span {
        color: $color1;
      }
      .svg-icon {
        fill: $color1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-User-Edit.vue